module.exports = __webpack_public_path__ + "static/assets/9755967b4c3db7812e2e13cbc71aa65d.gif";